module.exports = __webpack_public_path__ + "img/7.75e19c7a.jpg";